// Responsive image: serves WebP variants from /images/w/<name>-<width>.webp with the original as fallback.
const DIMS = {
  "event-1": [1800, 1034], "event-2": [1800, 986], "event-3": [1800, 1564], "event-4": [1800, 702], "event-5": [1800, 1200],
  "event-6": [1800, 1350], "event-7": [1800, 1200], "event-8": [1800, 1200], "event-9": [1800, 1350], "event-10": [1800, 1200], "event-11": [1800, 1350],
  "blob-1": [877, 900], "blob-2": [877, 900], "blob-3": [877, 900], "blob-4": [877, 900],
  "poster-01": [600, 900], "poster-02": [600, 900], "poster-03": [600, 900], "poster-04": [600, 900], "poster-05": [600, 900], "poster-06": [600, 900],
};
const WIDTHS = [480, 800, 1200, 1600];

export const Pic = ({ src, alt, sizes = "(min-width: 1024px) 50vw, 100vw", priority = false, className, imgRef, ...rest }) => {
  const name = src.split("/").pop().replace(/\.(jpg|png)$/, "");
  const dims = DIMS[name];
  if (!dims) return <img src={src} alt={alt} className={className} loading={priority ? "eager" : "lazy"} ref={imgRef} {...rest} />;
  const [w, h] = dims;
  const srcSet = WIDTHS.filter((x) => x <= w || x === 480).map((x) => `/images/w/${name}-${x}.webp ${x}w`).join(", ");
  return (
    <picture>
      <source type="image/webp" srcSet={srcSet} sizes={sizes} />
      <img ref={imgRef} src={src} alt={alt} width={w} height={h} className={className} sizes={sizes}
        loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} decoding={priority ? "sync" : "async"} {...rest} />
    </picture>
  );
};
